import { ThemeContextProvider } from '@gravitate-js/excalibrr'
import '@gravitate-js/excalibrr/dist/index.css'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import { QueryClientProvider } from '@tanstack/react-query'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { prefetchUtils, queryClient } from './api/client'
import { Main } from './components/Navigation/Main'
import { themeConfigs } from './components/Theming/themeconfigs'
import { AuthProvider } from './contexts/AuthContext'
import { EntityCacheProvider } from './contexts/EntityCacheContext'
import { NodeProvider } from './contexts/NodeContext'
import { ObjectProvider } from './contexts/ObjectContext'
import { cacheUtils } from './utils/indexedDB'

// Make feature flags available globally for WebSocket manager

export const App = () => {
  // Initialize performance monitoring and prefetching
  useEffect(() => {
    // Prefetch common data on app load
    if (localStorage.getItem('accessToken')) {
      prefetchUtils.prefetchCurrentUser()
    }

    // Clean up expired cache periodically
    const cacheCleanupInterval = setInterval(
      () => {
        cacheUtils.clearExpiredCache()
      },
      5 * 60 * 1000,
    ) // Every 5 minutes

    return () => {
      clearInterval(cacheCleanupInterval)
    }
  }, [])

  const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID

  if (!googleClientId) {
    console.warn('Google Client ID is not configured')
  }

  return (
    <QueryClientProvider client={queryClient}>
      <GoogleOAuthProvider clientId={googleClientId || ''}>
        <AuthProvider>
          <ObjectProvider>
            <EntityCacheProvider>
              <NodeProvider>
                <Router>
                  <ThemeContextProvider themeConfigs={themeConfigs}>
                    <Main />
                  </ThemeContextProvider>
                </Router>
              </NodeProvider>
            </EntityCacheProvider>
          </ObjectProvider>
        </AuthProvider>
      </GoogleOAuthProvider>
    </QueryClientProvider>
  )
}
